import styled from "styled-components/macro";

import {useToast} from "@chakra-ui/react";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity, useStoreSavedFeed} from "../../store/hooks";
import HeaderData from "../../components/header_data";
import {useFeedback} from "../../store/feedback";
import Button from "../../components/button";
import {useLoggedIn} from "../../store";
import NavLink from "../../components/nav_link";
import {usePublicSavedFeeds} from "../../api/custom_feeds";
import Pagination from "../../components/pagination";
import {useQuery} from "../../utils/router";
import CustomFeedLogo from "../../components/custom_feed_logo";
import {isPseudoCommunity} from "../../store/communites";
import {themecolors} from "../../utils/themecolors";
import {Star} from "lucide-react";

const Subscribe = styled(Button)``;
const Info = styled.div``;
const Title = styled.div``;
const Description = styled.div``;
const Logo = styled.div``;
const Text = styled.div``;

const Feed = styled(({className, feed}) => {
    const loggedIn = useLoggedIn();
    const toast = useToast();
    const savedFeed = useStoreSavedFeed(feed?.id);
    const handleSubscribe = async () => {
        if (!loggedIn) {
            // TODO: handle guest
        } else {
            try {
                // await onSubscribe(community);
            } catch {
                toast({
                    title: 'Something went wrong.',
                    status: 'error',
                    isClosable: true,
                })
            }
        }
    }
    return (
        <div className={className}>
            <Info>
                <Logo>
                    <CustomFeedLogo feedName={feed.feed_name} feedLogo={feed.logoId} />
                </Logo>
                <Text>
                    <Title>
                        <NavLink href={`/feed/${feed.id}/x/`} react_route>
                            {feed.feed_name}
                        </NavLink>
                        {loggedIn && <Subscribe onClick={handleSubscribe}>
                            {savedFeed
                                ? <Star size={18} fill={"#ffbe00"} style={{color: '#ffbe00'}} />
                                : <Star size={18} style={{color: '#70767b'}} />}
                        </Subscribe>}
                    </Title>
                    <Description>
                        {feed.description}
                    </Description>
                </Text>
            </Info>
        </div>
    );
})`
  font-size: 14px;
  padding-bottom: 16px;

  img {
    min-width: 32px;
    max-width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-top: 8px;
  }

  ${Info} {
    display: flex;
  }

  ${Title} {
    font-weight: 500;
  }
  
  ${Description} {
    font-size: 13px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Subscribe} {
    border-radius: 4px;
    background-color: inherit;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 700;
  }
  ${Text} {
    margin-left: 12px;
  }
`;

const Feeds = styled(({className}) => {

    const baseCommunity = useBaseCommunity();
    const style = useCommunityStyle(baseCommunity);

    const page = parseInt(useQuery().page || '1');
    const feedback = useFeedback();
    const feeds = usePublicSavedFeeds(feedback.channel, page)

    return (
        <div className={className}>
            <HeaderData title='Feeds' community={baseCommunity} community_style={style}/>
            <Header>
                <TopBar page={'Feeds'} />
                {!isPseudoCommunity(baseCommunity) &&
                    <>
                        <CommunityHeader community={baseCommunity}/>
                    </>
                }
            </Header>
            <SortBar community={baseCommunity} />
            <Container>
                <Wrapper>
                    <Main>
                        {feeds?.map((feed) => (
                            <Feed
                                key={feed.id}
                                feed={feed}
                            />
                        ))}
                    </Main>
                    <Pagination path={`/feeds?page=`} has_more page={page} />
                </Wrapper>
                <Sidebar sidebar={style && style.sidebar} community={baseCommunity} topics />
            </Container>
            <Footer />
        </div>
    );
})`
${Main} {
  padding: 16px;
}`;

export default Feeds;
